// src/index.tsx
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import { PowerBIEmbed } from "powerbi-client-react";
import Loader from "./Helpers/Loader/Loader";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
// import { msalConfig } from './authConfig';
import { getMsalConfig, loginRequest } from "./authConfig";

// const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// root.render(
//   <MsalProvider instance={msalInstance}>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </MsalProvider>
// );

const Index = () => {
  const [msalInstance, setMsalInstance] =
    useState<PublicClientApplication | null>(null);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        const msalConfig = await getMsalConfig();
        const msalApp = new PublicClientApplication(msalConfig);
        setMsalInstance(msalApp);
      } catch (error) {
        console.error("Failed to initialize MSAL", error); // Handle errors
      }
    };

    initializeMsal();
  }, []);

  if (!msalInstance) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  );
};

root.render(<Index />);

reportWebVitals();
